// @flow

import EventNames from '../constants/EventNames';
import Notifications from '../constants/Notifications';
import Scroll from '../components/Scroll';

export default class TabAccordionButton extends Scroll {
  #index: number = 0;

  /**
   * Initiate the component
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    this.setUp(pEl);
    const clickHandler = this.handleClickEvents.bind(this);
    this.addEventListener(EventNames.CLICK, clickHandler);
  }

  /**
   * Setup properties & validation
   */
  setUp(pEl: HTMLElement): void {
    this.#index = parseInt(pEl.dataset.index);

    if (Number.isNaN(this.#index)) {
      throw new Error('A index is required');
    }
  }

  /**
   * Executes when the user clicks on a tab
   */
  handleClickEvents(): void {
    this.notify(Notifications.ACTIVATE_TAB, { index: this.#index });
    this.scroll(this.el);
  }
}
